import React, {useContext, useEffect, useState} from "react";
import {RecordsManagementContext, ViewMangementContext} from "../StatesMangement/InitialiseContext";
import axios from "axios";
import './thirdPage.css'
import './Animation.css'
import {
    Elink,
    FetchEstimateDefaultRoomRecordsUrl,
    LastPageVisited,
    UpdateDefaultRoomInventoryUrl
} from "../CommonComponents/Routes";
import {Modal} from "react-bootstrap";
import CustomItemModal from "./CustomItemModal";
import {Animation} from "./Animation";
import MobileLinkLoader from "./MobileLinkLoader"
import {AnimationPrevious} from "./AnimationPrevious";
import {GetTextColor} from "./GetTextColor";

export default () => { // this is common component for add changes for all default rooms and switch between the default rooms
    const [BodyState, setBodyState] = useState("MINI-LOADING")
    const PageView = useContext(ViewMangementContext)
    const RecordsController = useContext(RecordsManagementContext)
    const [NewInventoryCount, increaseNewInventoryCount] = useState(0);
    let JobIsOpen = RecordsController.IsCustomerEditEstAftrBook
    const [, forceUpdate] = React.useState(0);
    const IsCustomerEditEstAftrBook = RecordsController.IsJobOpen
    const [SearchInventory, SetSearchInventory] = useState({});
    let CustomerInvReq = RecordsController.ML_Start.CustomerInventoryRequest;

    useEffect(async () => {//post request is send to "fetch_default_room_inventories" to fetch the inventory record of default room
        if (RecordsController.ML_Start.DefaultRoomsId[0]) {
            if (RecordsController.Click) {
                Animation('default-room-page', RecordsController.Click)
            }
            await axios({
                method: 'post',
                url: FetchEstimateDefaultRoomRecordsUrl,
                params: {estimate_key: Elink, default_room_id: RecordsController.ML_Start.DefaultRoomsId[0]}
            }).then(async (response) => {
                let Message = response.data.Message
                let current_location = window.location.href;
                let new_location = current_location.replace("client_estimate_mobile_link", "client_estimate");
                if(Message && Message.Status === "failed"){
                    window.location = new_location
                }
                else{
                    await RecordsController.SetDefaultRoomHash(response.data);
                    await SetSearchInventory(response.data.InventoryHash);
                    await response.data.InventoryQuantities > 0 ? RecordsController.SetActiveButton(true) : RecordsController.SetActiveButton(false)
                    await setBodyState("Get Details");
                    axios({
                        method: 'post',
                        url: LastPageVisited,
                        params: {estimate_key: Elink, last_visited_page: 'SHOW_MOBILE_LINK_DEFAULT_ROOMS'}
                    })
                }
            })
        }
        else{ // add condition if default room settings are changed ( there is no default room )
            RecordsController.SetClick("back")
            AnimationPrevious ( "back-go",  "default-room-page",  "SHOW_MOBILE_LINK_BEDROOM", PageView);
        }
    }, [])

    const InventoryDetails = (props) => {//component used to show the company inventories and customer's added inventories
        let Inventory = props.Inventory
        if (IsCustomerEditEstAftrBook) {
            return (
                <>
                    <div className={Inventory.Qty > 0 ? 'number-active' : 'number'} style={Inventory.Qty > 0 ? {backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)} : {}}>
                        <AddOrSubQty Inventory={Inventory} Id={Inventory.InventoryId ? Inventory.InventoryId : Inventory.Id} For={'-'} InventoryType={props.For}/>
                        <p className="text-design" style={{marginTop: "1rem"}}>{Inventory.Name}</p>
                        <div className="input-st">
                            <input type="text" pattern="[0-9]*" style={Inventory.Qty > 0 ? {fontSize: "15px!important",padding: "0px", backgroundColor: GetTextColor(CustomerInvReq.ButtonColor), color: CustomerInvReq.ButtonColor} : {fontSize: "15px!important",padding: "0px"} }
                                   defaultValue={Inventory.Qty > 0 ? Inventory.Qty : '' } disabled />
                        </div>
                        <AddOrSubQty Inventory={Inventory} Id={Inventory.InventoryId ? Inventory.InventoryId : Inventory.Id} For={'+'} InventoryType={props.For}/>
                    </div>
                </>
            )

        } else {
            return (
                Inventory.Qty
            )
        }
    }
    const updateInventories = (inventoryHash,inventory_id,type) => { // updating the inventories
        let isAlreadyExist = false,
            InventoryId = 0,
            COMPANY_INVENTORY = inventoryHash[inventory_id],
            COUNT = NewInventoryCount

        if (inventoryHash != null) {
            let inventories = inventoryHash
            Object.entries(inventories).map(([id, Inventory]) => {
                if (Inventory.Id === inventory_id || Inventory.InventoryId === inventory_id ) {
                    isAlreadyExist = true
                    InventoryId = id
                }
            })
            if (isAlreadyExist === true && InventoryId !== 0) {
                if (type === 'Increment') {
                    inventories[InventoryId].Qty += 1
                } else if (type === 'Decrement' && inventories[InventoryId].Qty > 0) {
                    inventories[InventoryId].Qty -= 1
                }
            } else if (isAlreadyExist === false && InventoryId === 0 && type === 'Increment') {
                inventories[inventory_id] = {
                    Id: inventory_id,
                    Name: COMPANY_INVENTORY.Name,
                    Qty: 1,
                    InventoryId: COMPANY_INVENTORY.Id,
                }
                increaseNewInventoryCount(COUNT += 1)
            }
            forceUpdate(n => !n)
            return inventories
        }
    }

    const UpdateQty = (inventory, type, inventory_id, inventory_type) => { // update custom and default room inventories
        let record
        if (inventory_type === "InventoryHash") {
            record = updateInventories(SearchInventory,inventory_id,type)
            RecordsController.SetDefaultRoomHash({
                ...RecordsController.DefaultRoomHash,
                InventoryHash : {
                    ...RecordsController.DefaultRoomHash.InventoryHash, ...record
                }
            });
            SetSearchInventory(record);
        }
        else{
            record = updateInventories(RecordsController.DefaultRoomHash.customInventoryHash,inventory_id,type)
                RecordsController.SetDefaultRoomHash({
                    ...RecordsController.DefaultRoomHash,
                    customInventoryHash : {
                        ...record
                    }
                });
        }
        let inventory_count = 0
        Object.entries(SearchInventory).map(([Id, Inven])=>{
            inventory_count += Inven["Qty"]
        })
        Object.entries(RecordsController.DefaultRoomHash.customInventoryHash).map(([Id, Inven])=>{
            inventory_count += Inven["Qty"]
        })
        inventory_count > 0  ? RecordsController.SetActiveButton(true) : RecordsController.SetActiveButton(false)
    }

    const AddOrSubQty = (props) => {//increase or decrease btns
        if (IsCustomerEditEstAftrBook) {
            return (
                <span className={props.For === '+' ? 'plus' : 'minus'}
                      onClick={() => UpdateQty(props.Inventory, props.For === '+' ? 'Increment' : 'Decrement', props.Id, props.InventoryType)}
                      style={{cursor: "pointer"}}>
                    {props.For}
                </span>
            )
        } else {
            return ''
        }
    }

    const searchText = (e) => {//used for searching the inventories
        let text = e.toLowerCase();
        let searchData = {}
        Object.entries(RecordsController.DefaultRoomHash.InventoryHash).map(([id, inventories]) => {
            let inventory = inventories.Name.toLowerCase();
            if (inventory.match(text)) {
                searchData[inventories.Id] = inventories
            }
        });
        SetSearchInventory(searchData);
    };

    const openCustomItemModal = () => {
        RecordsController.setCustomItemModal(true);
    }
    const handleModal = () => {
        RecordsController.setCustomItemModal(false);
    }

    const checkNextDefault = () => { // this component is used to go for next default room inventories
        ScrollTop();
        Animation("default-room-page",'next');
        let default_room_ids = RecordsController.ML_Start.DefaultRoomsId
        let default_room_id = RecordsController.DefaultRoomHash.DefaultRoomId
        let current_index = default_room_ids.indexOf(default_room_id)
        let NextDefaultRoomId = default_room_ids[ current_index + 1]
        if (NextDefaultRoomId) {
            setBodyState("MINI-LOADING")
            axios({//post request is send to the "update_inventories" function for updating the inventories of the estimate.
                method: 'post',
                url: UpdateDefaultRoomInventoryUrl,
                data: {
                    estimate_key: Elink,
                    default_room_estimate_id: RecordsController.DefaultRoomHash.DefaultEstimateRoomId,
                    default_room_inventories_hash: RecordsController.DefaultRoomHash.InventoryHash,
                    default_room_custom_inventories_hash: RecordsController.DefaultRoomHash.customInventoryHash,
                    default_room_ids: RecordsController.ML_Start.DefaultRoomsId,
                    update: true
                }
            }).then((response) => {// update the page content
                let Message = response.data.Message
                let current_location = window.location.href;
                let new_location = current_location.replace("client_estimate_mobile_link", "client_estimate");
                if(Message && Message.Text === "Expired Link"){
                    window.location = new_location
                }
                else{
                    if (Message && Message.Status && Message.Status === "failed") {
                        PageView.setAlertProperty({
                            Message: Message.Text,
                            Type: Message.Type,
                            Show: true,
                            AutoHide: true
                        })
                        window.location.reload();
                    }
                    if (response.data.NextDefaultRoomId) {
                        axios({
                            method: 'post',
                            url: FetchEstimateDefaultRoomRecordsUrl,
                            params: {estimate_key: Elink, default_room_id: response.data.NextDefaultRoomId}
                        }).then(async (response) => {
                            await RecordsController.SetDefaultRoomHash(response.data);
                            await SetSearchInventory(response.data.InventoryHash);
                            await setBodyState("Get Details");
                            response.data.InventoryQuantities > 0 ? RecordsController.SetActiveButton(true) : RecordsController.SetActiveButton(false)
                        })
                    }
                }
            })
        }
        else{
            RecordsController.SetClick('next');
            AnimationPrevious ( "next-go",  "default-room-page",  "SHOW_MOBILE_LINK_MY_ROOMS", PageView);
        }

    }

    const showPrevious = () => { // go to previous page (either bedroom page or default room page )
        ScrollTop();
        RecordsController.SetClick('back');
        let default_room_ids = RecordsController.ML_Start.DefaultRoomsId
        let default_room_id = RecordsController.DefaultRoomHash.DefaultRoomId
        let current_index = default_room_ids.indexOf(default_room_id)
        let PreviousDefaultRoomId = default_room_ids[ current_index - 1]
        RecordsController.setOtherBedrooms(RecordsController.ML_Start.BedroomCount)
        if (PreviousDefaultRoomId){ // if previous default room is present
            AnimationPrevious ( "back-go",  "default-room-page",  "SHOW_MOBILE_LINK_DEFAULT_ROOMS", PageView);
            setBodyState("MINI-LOADING");
            axios({method: 'post',
                url: FetchEstimateDefaultRoomRecordsUrl,
                params: {estimate_key: Elink, default_room_id: PreviousDefaultRoomId}})
                .then(async (response) => {
                    await RecordsController.SetDefaultRoomHash(response.data);
                    await SetSearchInventory(response.data.InventoryHash);
                    await setBodyState("Get Details");
                    response.data.InventoryQuantities > 0 ? RecordsController.SetActiveButton(true) : RecordsController.SetActiveButton(false)
                })
        }
        else{
            AnimationPrevious ( "back-go",  "default-room-page",  "SHOW_MOBILE_LINK_BEDROOM", PageView);
        }
    }

    const skipPage = () => { // this component is used to Skip current page and move to next page ( default room or my home page)
        ScrollTop();// method to help scroll up the content when we move between pages
        let default_room_ids = RecordsController.ML_Start.DefaultRoomsId
        let default_room_id = RecordsController.DefaultRoomHash.DefaultRoomId
        let current_index = default_room_ids.indexOf(default_room_id)
        let NextDefaultRoomId = default_room_ids[ current_index + 1]
        if (NextDefaultRoomId) { // go to next default room page if nex default room is present
            RecordsController.SetClick('next');
            AnimationPrevious ( "next-go",  "default-room-page",  "SHOW_MOBILE_LINK_DEFAULT_ROOMS", PageView);
            setBodyState("MINI-LOADING")
            axios({
                method: 'post',
                url: FetchEstimateDefaultRoomRecordsUrl,
                params: {estimate_key: Elink, default_room_id: NextDefaultRoomId}
            }).then(async (response) => {
                    await RecordsController.SetDefaultRoomHash(response.data);
                    await SetSearchInventory(response.data.InventoryHash);
                    response.data.InventoryQuantities > 0 ? RecordsController.SetActiveButton(true) : RecordsController.SetActiveButton(false)
                    await setBodyState("Get Details");
            })
        }
        else{
            RecordsController.SetClick('next');
            AnimationPrevious ( "next-go",  "default-room-page",  "SHOW_MOBILE_LINK_MY_ROOMS", PageView);
        }
    }

    // this method is used to scroll top while switching the default room pages
    function ScrollTop(){
        const element = document.getElementById("inventoryDiv");
        element.scrollLeft = 0 ;
        element.scrollTop = 0;
    }

    return (
        <>
            <section className="bg-col" style={{height: "100vh", background: CustomerInvReq.BackgroundColor}}>
                <Modal className="alert-modal" show={!JobIsOpen || RecordsController.ML_Start.InventoryType } onHide={JobIsOpen || !RecordsController.ML_Start.InventoryType } id ="keypadModal"
                       style={{borderRadius: "30px",marginTop: "18%"}}>
                    <Modal.Body style={{height:"250px",textAlign: "center"}}> <b style={{fontSize: "115%"}}>
                        <img id="start-img" src={process.env.PUBLIC_URL + "/Images/alert.png"} alt="image" style={{height:"25%"}}/><br/><br/>
                        {
                            RecordsController.ML_Start.InventoryType && JobIsOpen ? "This link is not valid for percentage inventory" :
                                "This job is currently booked, please contact your moving company to make any edits."
                        }
                    </b></Modal.Body>
                </Modal>
                <div className="container">
                    <div className="row d-flex justify-content-center align-items-center default-room-page">
                        <div className="col-sm-12 col-md-8 col-lg-6 col-xl-5 " >
                            <div className="card-st text-center">
                                <div className="logo text-center room-div" style={{paddingTop: "4.5rem!important"}}>
                                    <div className="arrow" >
                                        <i className="fa fa-angle-left" style={{cursor: "pointer",color: GetTextColor(CustomerInvReq.BackgroundColor) }} onClick={() => showPrevious()}></i>
                                    </div>
                                    <div className="logo-image-desktop-2">
                                        <img src={RecordsController.ML_Start.CompanyLogo ? RecordsController.ML_Start.CompanyLogo :
                                            process.env.PUBLIC_URL + "/Images/mobileLinkLogo.png"} alt="image"/>
                                    </div>
                                    <div className="skip">
                                        <a href="#main" onClick={() => skipPage()} style={{color: GetTextColor(CustomerInvReq.BackgroundColor)}}>SKIP</a>
                                    </div>
                                </div>
                                {/* add loader, sometimes it take more time to fetch the details from backend */}
                                { BodyState === "MINI-LOADING" ? <MobileLinkLoader/> :
                                    <>
                                        <div className="text-st">
                                            <h3 style={{marginTop: "1%!important", color: GetTextColor(CustomerInvReq.BackgroundColor)}}>
                                                {CustomerInvReq.EditVerbiage.default === "false" ? CustomerInvReq.EditVerbiage.default_room_heading : "Let's add item to your"}<br/>{RecordsController.DefaultRoomHash.DefaultRoomName}.</h3>
                                        </div>
                                        <div className="form-group search-bar">
                                            <input type="text" className={"form-control"}
                                                   onKeyUp={(e) => searchText(e.target.value)} placeholder={"Item Search..."} />
                                        </div>
                                        <div className="list-group" id={"inventoryDiv"} style={{height: "42vh",overflowY: "scroll", marginBottom: "2.5%", scrollbarWidth: "none", msOverflowStyle: "none"}}>
                                        {
                                            Object.entries(RecordsController.DefaultRoomHash.customInventoryHash).reverse().map(([id, Inventory]) => {
                                                return <InventoryDetails key={id}
                                                                         Inventory={Inventory}
                                                                         For='CustomInventoryHash'/>
                                            })
                                        }{
                                            Object.entries(SearchInventory).map(([id, Inventory]) => {
                                                return <InventoryDetails key={id}
                                                                         Inventory={Inventory}
                                                                         For='InventoryHash'/>
                                            })
                                        }
                                        </div>
                                    </>
                                }

                                {
                                    CustomerInvReq.AllowCustomItem ?
                                        <>
                                            <Modal className={"modal-dialog-centered"} id="custom-item-modal"  show={RecordsController.CustomItemModal}
                                                   onHide={() => handleModal()}>
                                                <Modal.Header><h4 className="custom-item-heading">Custom Item</h4>
                                                    <button onClick={handleModal} style={{color: "black", border: "white", height: "5%"}}>
                                                        <i className="fa fa-times" aria-hidden="true" style={{color: GetTextColor(CustomerInvReq.BackgroundColor), fontSize: "18px"}}></i>
                                                    </button>
                                                </Modal.Header>
                                                <Modal.Body > <CustomItemModal
                                                    DefaultEstimateRoomId={RecordsController.DefaultRoomHash.DefaultEstimateRoomId}
                                                    DefaultRoomId={RecordsController.DefaultRoomHash.DefaultRoomId}
                                                    CustomInventoryHash={RecordsController.DefaultRoomHash.customInventoryHash}
                                                /> </Modal.Body>
                                            </Modal>
                                            <button className="btn btn-st-model" data-toggle="modal" data-target="#Modal"
                                                    style={{backgroundColor: CustomerInvReq.ButtonColor, color: GetTextColor(CustomerInvReq.ButtonColor)}}
                                                    onClick={() => {openCustomItemModal()}}><b>Custom Item</b></button>
                                        </>
                                        : ''
                                }
                                <br/>
                                <button className="btn btn-st-white-3" type="submit"
                                        style={ RecordsController.ActiveButton ? {
                                            backgroundColor: CustomerInvReq.ButtonColor,
                                            color: GetTextColor(CustomerInvReq.ButtonColor),
                                            borderRadius: "8px"
                                        } : {borderRadius: "8px"}}
                                        onClick={ () => RecordsController.ActiveButton ?
                                            checkNextDefault({DefaultRoomHash: RecordsController.DefaultRoomHash}) : ''}>
                                    <b>NEXT</b>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

